import { graphql } from 'gatsby';
import React from 'react';

import Default from '~/templates/Default';

import Seo from '~/layout/SEO';

import BlockList from '~/components/BlockList';
import CtaBar from '~/components/blocks/acf/CtaBar';

const Page = ({ data }) => {
    const {
        wp: {
            siteSettings: {
                siteSettings: { leftTitle, rightTitle, footerCtas }
            }
        },
        wpPage: {
            blocks,
            pageOptions: { includeTopFooter }
        }
    } = data;

    return (
        <Default>
            <BlockList {...{ blocks }} />

            {includeTopFooter ? (
                <CtaBar
                    variant="findYourCarWash"
                    backgroundColor="blue"
                    ctas={footerCtas}
                    globalBlockOptions={{
                        marginBottom: 'none'
                    }}
                    {...{ leftTitle, rightTitle }}
                />
            ) : null}
        </Default>
    );
};

export default Page;

export const Head = ({
    location,
    data: {
        wpPage: { seo: seoFragment }
    }
}) => <Seo {...{ location, seoFragment }} />;

export const query = graphql`
    query Page($id: String!) {
        wp {
            siteSettings {
                siteSettings {
                    leftTitle
                    rightTitle
                    footerCtas {
                        link {
                            url
                            title
                        }
                    }
                }
            }
        }
        wpPage(id: { eq: $id }) {
            id
            title
            pageOptions {
                includeTopFooter
            }
            seo {
                ...SeoFragment
            }
            blocks {
                ...BlockListFragment
            }
        }
    }
`;
